import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { QuienesSomos } from "./components/QuienesSomos";
import { Distintivos } from "./components/Distintivos";
import { Servicios } from "./components/Servicios";
import { Segmentos } from "./components/Segmentos";
import { Testimonios } from "./components/Testimonios";
import { Contacto } from "./components/Contacto";
import { Footer } from "./components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-cream font-sans text-cafe-ink antialiased">
      <div className="noise-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <QuienesSomos />
        <Distintivos />
        <Servicios />
        <Segmentos />
        <Testimonios />
        <Contacto />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            borderRadius: "4px",
            border: "1px solid #E5E1DD",
            fontFamily: "'Plus Jakarta Sans', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
